import whenReady from '../../../javascripts/utils/whenReady';

whenReady().then(() => {
  const listTables = document.querySelectorAll<HTMLElement>(
    '.list-table__container',
  );

  listTables.forEach((listTable) => {
    const batchSize = 10;
    const filterItems = Array.from(
      listTable.querySelectorAll<HTMLAnchorElement>(
        '.filter-item > a[data-category]',
      ),
    );

    const lists = listTable.querySelectorAll('.list-table__items');
    lists.forEach((list) => {
      const listItems = Array.from(
        list.querySelectorAll<HTMLElement>('.list-table__item[data-category]'),
      );

      const button = list.querySelector<HTMLButtonElement>('.load-more');

      let activeCategory: string | null = null;
      let visibleCount = batchSize;

      const getVisibleItems = () => {
        if (!activeCategory) {
          return listItems;
        }

        return listItems.filter(
          (item) => item.dataset.category === activeCategory,
        );
      };

      const updateLoadMoreButton = (visibleItems: HTMLElement[]) => {
        if (!button) return;

        const shouldHide = visibleCount >= visibleItems.length;

        button.hidden = shouldHide;
        button.classList.toggle('hidden', shouldHide);
      };

      const render = () => {
        const visibleItems = getVisibleItems();

        // Hide all list items
        listItems.forEach((item) => {
          item.classList.add('hidden');
        });

        // Show filtered list items
        visibleItems.slice(0, visibleCount).forEach((item) => {
          item.classList.remove('hidden');
        });

        // Show/Hide 'load more' button
        updateLoadMoreButton(visibleItems);
      };

      // Active filter
      const setActiveFilter = (activeFilter: HTMLAnchorElement | null) => {
        filterItems.forEach((filterItem) => {
          filterItem.classList.remove('button--active');
        });

        if (activeFilter) {
          activeFilter.classList.add('button--active');
        }
      };

      const resetView = () => {
        visibleCount = batchSize;
        render();
      };

      // Category filters
      filterItems.forEach((filterItem) => {
        filterItem.addEventListener('click', (event) => {
          event.preventDefault();

          const category = filterItem.dataset.category || null;
          activeCategory = category === 'all' ? null : category;

          setActiveFilter(filterItem);
          resetView();
        });
      });

      // Load more
      if (button) {
        button.addEventListener('click', () => {
          visibleCount += batchSize;
          render();
        });
      }

      // Initial render
      resetView();
    });
  });
});
